import { render, staticRenderFns } from "./InformationStatistics.vue?vue&type=template&id=acab58fa&scoped=true"
import script from "./InformationStatistics.vue?vue&type=script&lang=js"
export * from "./InformationStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acab58fa",
  null
  
)

export default component.exports